import { EntityTypes } from 'context/entityContext';

interface IEntityUrlArgs {
  entityId: string | undefined;
  entityType: EntityTypes | undefined | string;
  parentEntityId?: string;
  topic?: string | string[];
  hash?: string;
}

/** This returns an entity URL based on the existence of a parentEntityId */
const getEntityUrl = (args: IEntityUrlArgs): string => {
  const {
    entityId,
    entityType,
    parentEntityId,
    topic = 'performance/streaming',
    hash = '',
  } = args;

  if (!entityId || !entityType) {
    // eslint-disable-next-line no-console
    console.warn(
      'entityId and entityType are required arguments. Please provide those when using the getEntityUrl helper.'
    );
  }

  const topicString = Array.isArray(topic) ? topic.join('/') : topic;

  return parentEntityId
    ? `/entity/${entityType}/${parentEntityId}/version/${entityId}/${topicString}${hash}`
    : `/entity/${entityType}/${entityId}${
        entityType === 'label' ? '' : `/${topicString}`
      }${hash}`;
};

export default getEntityUrl;
